<template lang='pug'>
  div
    app-header(:white='true' class='u-absolute')

    section(class='u-flex u-items-center u-relative' style='min-height:85vh')
      figure(class='u-m0 u-absolute u-left-0 u-right-0 u-top-0 u-bottom-0 u-bg-opacity' style='z-index:-1;background-image: url(/images/about.jpg);background-size: cover;background-position: 50% 50%;')

      div(class='o-about')
        h2(class='u-line-1 u-fz-h0' data-aos='fade-up' )
          span(class='u-white u-block') ¿Quién es&nbsp;
          span(class='u-block u-color-secondary u-fw-bold ') {{company.name}}?


    section(class='u-py5')
      article(class='c-about o-about-left' )
        div(class='c-about__image u-6/12@tablet' data-aos='fade-left' )
          figure(style='background-image: url(/images/description.jpg)')

        div(class='c-about__content u-flex-1' style='margin-top: -10rem' data-aos='fade-up' )
          p(class='c-about__title u-4/12@tablet') Empresa Líder
          div(class='u-mb4' v-html='company.description')
            //- p Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
          img(src='/images/car_pavill2.png')

      article(class='c-about o-about-right')
        div(class='c-about__image u-6/12@tablet' data-aos='fade-right' )
          figure(style='background-image: url(/images/vision.jpg)')

        div(class='c-about__content u-flex-1' data-aos='fade-left' )
          p(class='c-about__title') Visión
          div(class='u-mb4' v-html='company.vision')
            //- p Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.

      article(class='c-about o-about-left')
        div(class='c-about__image u-6/12@tablet' data-aos='fade-left' )
          figure(style='background-image: url(/images/mission.jpg)')

        div(class='c-about__content u-flex-1' data-aos='fade-right' )
          p(class='c-about__title') Misión
          div(class='u-mb4' v-html='company.mission')
            //- p Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.


    section(class='o-wrapper u-mb5')
      h2(class='u-center u-fz-h1 u-line-1 u-mt3' data-aos='fade-up' )
        span(class='u-fw-light') Marcamos la&nbsp;
        strong(class='u-color-secondary') Diferencia

      swiper(:options='swiperFeatures' class='u-12/12')
        swiper-slide(v-for='(feature, index) in features', :key='index' style='height:auto' class='u-flex')
          div(class='c-feature u-flex-1' data-aos='fade-up' )
            figure(class='u-mt0 u-mb0 u-mx-auto u-px3' style='width:80px')
              img(:src='feature.imageUrl')
            p(class='u-fw-bold u-uppercase u-color-primary') {{feature.title}}
            p(class='u-color-tex u-mb0') {{feature.description}}


    section
      h2(class='u-center u-fz-h1 u-line-1 u-mt3' data-aos='fade-up' )
        span(class='u-fw-light') Juntos por un mismo&nbsp;
        strong(class='u-color-secondary') Sueño
      div(class='m-p-g o-wrapper u-overflow-auto')
        div.m-p-g__thumbs(data-google-image-layout data-max-height='320')
          //- img.m-p-g__thumbs-img(src='http://unsplash.it/600/400?image=198', data-full='http://unsplash.it/1200/800?image=198')
          img.m-p-g__thumbs-img(v-for='image in company.gallery'
            :src='image.urlThumb', :data-full='image.url')

        .m-p-g__fullscreen

    app-footer(class='u-mt5')
</template>

<script>
  import { mapGetters } from 'vuex'
  // import MaterialPhotoGallery from 'material-photo-gallery'

  export default {
    name: 'AboutScreen',
    data () {
      return {
        swiperFeatures: {
          slidesPerView: 5,
          autoplay: 5000,
          breakpoints: {
            889: {
              slidesPerView: 4
            },
            778: {
              slidesPerView: 3
            },
            560: {
              slidesPerView: 2
            },
            320: {
              slidesPerView: 1
            }
          }
        },
        features: [
          {
            id: 1,
            title: 'Buen trato al cliente',
            imageUrl: '/images/icon1.png',
            description: 'Atención personalizada en el servicio y buen trato al cliente, siempre con responsabilidad, respeto y honradez.'
          },
          {
            id: 2,
            title: 'Flota moderna',
            imageUrl: '/images/icon2.png',
            description: 'Pavill cuenta con vehículos modernos para brindar comodidad en su trayectoria, seguridad y confort.'
          },
          {
            id: 3,
            title: 'Conductores con experiencia',
            imageUrl: '/images/icon3.png',
            description: 'Nuestros conductores cuentan con amplia experiencia y están en constante capacitación.'
          },
          {
            id: 4,
            title: 'Central telefónica moderna',
            imageUrl: '/images/icon4.png',
            description: 'Central telefónica moderna disponible las 24 horas del día, envio de taxi a domicilio y delivery.'
          },
          {
            id: 5,
            title: 'Servicio de taxi por App',
            imageUrl: '/images/icon5.png',
            description: 'Para un servicio más rápido, confiable, y personal, le ofrecemos el servicio de aplicación desde su celular.'
          }
        ]
      }
    },

    computed: {
      ...mapGetters({
        company: 'company'
      })
    },

    mounted () {
      setTimeout(() => {
        const elem = document.querySelector('.m-p-g')
        /* eslint-disable */
        if (elem) {
          new MaterialPhotoGallery(elem)
        }
        /* eslint-enable */
      }, 500)
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/screens/About/components/AboutScreen.vue